import { render, staticRenderFns } from "./Type10Block.vue?vue&type=template&id=691440ee&scoped=true&"
import script from "./Type10Block.vue?vue&type=script&lang=js&"
export * from "./Type10Block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691440ee",
  null
  
)

export default component.exports